import React from 'react';
import { Container, Row, Col} from 'react-bootstrap';

const Servicesbanner = ({ title, highlight }) => {
  return (
    <>
      <section className='banner sub'>
        <Container>
          <Row>
            <Col md={12}>
              <h1>{title} <span className='text-gradient'>{highlight}</span></h1>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Servicesbanner